/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Synchronize } from '../../assets/themes/OPL/img/icons/Synchronize.svg';

function SynchronizeButton({ ...props }) {
    const { classes, callback, callbackParam, tooltipTitle, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Synchronize}
            color={color}
            tooltipTitle={tooltipTitle}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

SynchronizeButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    tooltipTitle: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default SynchronizeButton;
